import { lazy } from "react";

export const RehabilitatorsAsync = lazy(() => import("./Rehabilitators"));
